module.exports = __webpack_public_path__ + "static/video-background-only-740cd046ba8cb7acf90e25961c76c729.mp4";